import React, { useEffect, useState, useCallback } from 'react'
import './index.scss'
import ReusableButton from '../../reusableComponents/button/customButton'
import HuntItemsData from './items'
import { connect } from 'react-redux'
import Loader from '../../reusableComponents/loader/Loader'
import { huntPlannerActiveOtions } from '../../../../action/huntplanner-selected-options'
import { fetchGetHuntUnitList, fetchGetHuntList } from '../../../../action/huntPlanner-api-actions'
import SortModel from '../../reusableComponents/sortModel/sortModel'
import UpgradeButton from './upgrade-button'
import { huntPlannerRightMenuBarexpand } from '../../../../action/huntplanner-menu-bar'

const DEBOUNCE_DELAY = 500; // Adjust as needed
const INITIAL_DELAY = 100; // 0.1 seconds


const HuntPlannerRightToolBar = (props) => {
  const [sorting, setSorting] = useState(true)
  const [filteredata, setFilteredata] = useState([])
  const [spinLoader, setSpinLoader] = useState(false)
  const [selectedTab, setSelectedTab] = useState('Units')
  const [previousPayload, setPreviousPayload] = useState()

  const [hasInitialCalled, setHasInitialCalled] = useState(false);
  const [debounceTimeout, setDebounceTimeout] = useState(null);

  const getDefaultSort = (tab) =>
    tab === 'Units' ? 'Alphabetical' : 'Alphabatical';

  const [sortOption, setSortOption] = useState(getDefaultSort(selectedTab))

  useEffect(() => {
    // When tab changes, reset the default sort
    setSortOption(getDefaultSort(selectedTab));
  }, [selectedTab]);


  // Initial delayed API call (ensures it runs only once)
  useEffect(() => {
    const timer = setTimeout(() => {
      filterHuntUnitList();
      setHasInitialCalled(true);
    }, INITIAL_DELAY);

    return () => clearTimeout(timer); // Cleanup on unmount
  }, []);

  // Debounced API call when props.moreFilterOptions updates
  useEffect(() => {
    if (
      hasInitialCalled && // Ensures this effect doesn't run before the initial call
      props.moreFilterOptions.StateAbbreviation &&
      props.moreFilterOptions.HuntTypeKey &&
      props.moreFilterOptions.Species
    ) {
      if (debounceTimeout) clearTimeout(debounceTimeout);

      const newTimeout = setTimeout(() => {
        if (selectedTab == 'Units') {
          filterHuntUnitList();
        }
        else {
          filterHuntList()
        }
      }, DEBOUNCE_DELAY);

      setDebounceTimeout(newTimeout);
    }

    return () => clearTimeout(debounceTimeout);
  }, [props.moreFilterOptions, hasInitialCalled]);


  // useEffect(() => {
  //     console.log('---------------hitted effect --------------')
  //     filterHuntUnitList()
  // }, [])

  // useEffect(() => {
  //     if (props.moreFilterOptions.StateAbbreviation && props.moreFilterOptions.HuntTypeKey && props.moreFilterOptions.Species) {
  //         console.log('--------------- again hitted effect --------------')
  //         filterHuntUnitList()
  //     }
  // }, [props.moreFilterOptions])


  let filterHuntUnitList = (childProp, name) => {
    let payload = {
      StateAbbreviation: props.payloadObject.StateAbbreviation,
      Species: props.payloadObject.Species,
      HuntTypeKey: props.payloadObject.HuntTypeKey,

      method: props.moreFilterOptions.method,
      season: props.moreFilterOptions.season,
      sex: props.moreFilterOptions.sex,
      harvestSuccess: props.moreFilterOptions.harvestSuccess,
      trophyPotential: props.moreFilterOptions.trophyPotential,
      publicLand: props.moreFilterOptions.publicLand,

      DrawChoice: props.moreFilterOptions.DrawChoice,
      DrawPoints: props.moreFilterOptions.DrawPoints,
      DrawPercentage: props.moreFilterOptions.DrawPercentage,
      Choice: props.moreFilterOptions.Choice,
      ExactPoints: props.moreFilterOptions.ExactPoints,

      orderBy: childProp ? childProp : 'geo_name',
    };

    const isEqual = JSON.stringify(payload) != JSON.stringify(previousPayload);

    if (isEqual || name == 'Units') {
      setPreviousPayload(payload)
      //Remove undefined, null, and empty string values
      Object.keys(payload).forEach((key) => {
        if (payload[key] === undefined || payload[key] === null || payload[key] === '') {
          delete payload[key];
        }
      });

      setSpinLoader(true)
      setFilteredata([])

      props.fetchGetHuntUnitList(payload)
        ?.then((res) => {
          setFilteredata(res)
          setSpinLoader(false)
        })
        .catch((error) => {
          console.error('API Error:', error);
        });
    }
  }

  let filterHuntList = (childProp) => {
    let payload = {
      StateAbbreviation: props.payloadObject.StateAbbreviation,
      Species: props.payloadObject.Species,
      HuntTypeKey: props.payloadObject.HuntTypeKey,
      harvestSuccess: props.moreFilterOptions.harvestSuccess,
      drawOdds: props.moreFilterOptions.drawOdds,
      selectedPoints: props.moreFilterOptions.selectedPoints,
      trophyPotential: props.moreFilterOptions.trophyPotential,
      publicLand: props.moreFilterOptions.publicLand,
      method: props.moreFilterOptions.weapon,
      season: props.moreFilterOptions.season,
      sex: props.moreFilterOptions.sex,
      Choice: props.moreFilterOptions.Choice,
      DrawChoice: props.moreFilterOptions.DrawChoice,
      DrawPoints: props.moreFilterOptions.DrawPoints,
      DrawPercentage: props.moreFilterOptions.DrawPercentage,
      ExactPoints: props.moreFilterOptions.ExactPoints,
      orderBy: childProp ? childProp : 'apply_for'
    };

    //Remove undefined, null, and empty string values
    Object.keys(payload).forEach((key) => {
      if (payload[key] === undefined || payload[key] === null || payload[key] === '') {
        delete payload[key];
      }
    });

    setFilteredata([])
    setSpinLoader(true)

    console.log(payload, '===================payload')

    props.fetchGetHuntList(payload)
      .then((res) => {
        setFilteredata(res)
        setSpinLoader(false)
        props.huntPlannerRightMenuBarexpand()
      })
      .catch((error) => {
        console.error('API Error:', error);
      });
  }

  let onSortClick = () => {
    setSorting(!sorting)
  }

  let handleClick = (e) => {
    if (e.target.name == 'Hunts') {
      setSelectedTab('Hunts')
      filterHuntList()
    }
    else if (e.target.name == 'Units') {
      setSelectedTab('Units')
      filterHuntUnitList('', e.target.name)
    }
  }

  return (
    <div className='ht-rt-menu-container'>

      <div className='ht-rt-menu-child-one-container'>

        <ReusableButton
          buttonName="Units"
          className={`lets-go-button-label  ${selectedTab == 'Units' ? 'text-color-white' : 'text-color-black'}`}
          label={"Units"}
          onClick={handleClick}
          size="small"
          borderRadius='25px'
          buttonWidth="200px"
          buttonHeight="38px"
          variant={selectedTab == 'Units' ? "secondary" : "primary"}
          borderColor={selectedTab == 'Units' ? "" : "#535151"}
        />

        <ReusableButton
          buttonName="Hunts"
          className={`lets-go-button-label  ${selectedTab != 'Units' ? 'text-color-white' : 'text-color-black'}`}
          label={'Hunts'}
          onClick={handleClick}
          size="small"
          buttonWidth="200px"
          buttonHeight="38px"
          borderRadius='25px'
          variant={selectedTab != 'Units' ? "secondary" : "primary"}
          borderColor={selectedTab != 'Units' ? "" : "#535151"}
        />
      </div>
      {props.huntPlannerFilterOptions?.huntResearch ?
        null :
        <UpgradeButton className={'upgrade-button-style'}></UpgradeButton>
      }

      <div className='ht-rt-menu-child-two-container'>
        <div className='ht-rt-display-header'>
          <p className='ht-rt-menu-text heading-style font-style-roboto'>Matching {props.filterCount.unitCount} Units / {props.filterCount.drawCount} Hunts</p>
        </div>
        <div className='sorting-container'>
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <p className='ht-rt-menu-text sorting-style font-style-roboto-bold'>Sort by</p>
          </div>

          <p className="arrow-container" onClick={() => { onSortClick() }}>
            <>
              <span className="arrow up"></span>
              <span className="arrow down"></span>
            </>
          </p>
        </div>
        {!sorting && <SortModel filterHuntUnitList={filterHuntUnitList} filterHuntList={filterHuntList} selectedTab={selectedTab} closeSortMenu={() => { onSortClick() }} sortOption={(option) => setSortOption(option)} activeSelection={sortOption}></SortModel>}
      </div>



      <div className='ht-rt-menu-child-three-container'
        style={{
          maxHeight: props.huntPlannerFilterOptions?.huntResearch ?
            '' : '60vh'
        }}
      >
        {filteredata && filteredata.length > 0 && filteredata.map((item, index) => {
          return (
            <HuntItemsData
              key={index}
              huntData={item}
              huntPlannerHunts={selectedTab === "Hunts"}
              huntPlannerUnits={selectedTab === "Units"}
              selectedFilterOptions={props.moreFilterOptions}
              selectedTab={selectedTab}
              unitDetailsResponse={filteredata}
              unitDetails={item}></HuntItemsData>
          )
        })}
      </div>

      {spinLoader && <Loader position={'absolute'} left={'42%'} width={'30px'}></Loader>}

    </div>
  )
}

const mapStateToProps = state => ({
  huntplannerStatesData: state.huntplannerStatesData,
  auth: state.auth,
  huntplannerMapReference: typeof state.huntplannerMapReference === 'function' ? state.huntplannerMapReference() : null,
  currentSubscription: state.currentSubscription,
  huntPlannerFilterOptions: state.huntPlannerFilterOptions
})

const mapDispatchToProps = dispatch => ({
  huntPlannerActiveOtions: (payload) => dispatch(huntPlannerActiveOtions(payload)),
  fetchGetHuntUnitList: (payload) => dispatch(fetchGetHuntUnitList(payload)),
  fetchGetHuntList: (payload) => dispatch(fetchGetHuntList(payload)),
  huntPlannerRightMenuBarexpand: () => dispatch(huntPlannerRightMenuBarexpand())
})

export default connect(mapStateToProps, mapDispatchToProps)(HuntPlannerRightToolBar)
